'use client'

/**
 * Purpose: The only place in the app that calls `posthog.capture` directly.
 * Every event-telemetry module (dead-link, diary-face, and the general
 * interaction module) funnels through this so event dispatch has one seam —
 * a single point to inspect, test, or extend for every event PostHog receives.
 * Inputs: Event name and optional properties object.
 * Outputs: None — fires the PostHog capture call as a side effect.
 */
import posthog from 'posthog-js'
export function capture(eventName: string, properties?: Record<string, unknown>): void {
  if (properties === undefined) {
    posthog.capture(eventName)
  } else {
    posthog.capture(eventName, properties)
  }
}
